import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AngularFireStorage } from "angularfire2/storage";
import { Observable } from "rxjs/Observable";
import { Utilities } from "../../providers/utilities";
import { toArray, isObject, has } from "lodash";

@Component({
  selector: "app-upload-file",
  templateUrl: "upload-file.html",
})
export class UploadFileComponent implements OnInit {

  @Input() public form: FormControl;
  @Input() public accept: string = "image/*";
  @Input() public type: string;
  @Input() public buttonName: string;
  @Input() public disabled = false;
  @Input() public labelName: string = null;
  @Input() public filePath: string;
  @Input() public isMultiple = false;
  @Input() public isOptimized = false;
  @Input() public optimizedRelation: '1:1' | '16:9' = '1:1';
  @Input() public custom = false;
  @Output() public uploadCustom = new EventEmitter();
  @Output() public uploadEnd = new EventEmitter();

  public uploadPercent: Observable<number>;
  public downloadURL: Observable<string>;
  public id: string;
  public hash = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split("");

  constructor(
    private storage: AngularFireStorage,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.id = Math.floor(Math.random() * this.hash.length).toString();
    this.accept = this.calculateType();
  }

  public open() {
    document.getElementById(this.id).click();
  }

  public verifiedUpload(event) {
    if (this.custom) {
      this.uploadCustom.emit(event);
    } else {
      this.uploadFile(event);
    }
  }

  public clearFile(position = null) {
    this.utilities.Alert.create({
      buttons: [{
        handler: () => {
          if (position >= 0) {
            const current: string[] = this.form.value;
            if (this.isMultiple) {
              current.splice(position, 1);
              this.uploadEnd.emit(current);
              // this.form.setValue(current);
            } else {
              this.uploadEnd.emit();
              // this.form.setValue("");
            }
          } else {
            this.uploadEnd.emit();
            // this.form.setValue("");
          }
          return;
        },
        text: "Ok",
      }, {
        role: "cancel",
        text: "Cancel",
      }],
      message: "Are you sure you want to delete the current file?",
      title: "Alert",
    }).present();
  }

  public preview(image) {
    this.utilities.Modal.create("PreviewPage", { image }).present();
  }

  private async uploadFile(event) {
    const files = event.target.files;
    const promises: any[] = [];

    if (files.length > 0) {
      const load = this.utilities.setLoading();
      for (let i = 0; i < files.length; i++) {
        promises.push(await this.storage.upload(`${this.filePath}/${this.id}_${files[i].name}`, files[i]));

        if (files.length - 1 === i) {
          this.endUpload(promises, load);
        }
      }
    }
  }

  private endUpload(promises, load) {
    return Promise.all(promises)
      .then((result: any[]) => {
        if (this.isMultiple) {
          const rs = [];
          result.map((file) => {
            if (this.isOptimized) {
              rs.push({ [file.metadata.name]: { url: file.downloadURL, path: this.filePath, name: file.metadata.name, relation: this.optimizedRelation } });
            } else {
              rs.push(file.downloadURL);
            }
          });

          if (this.isOptimized) {
            return this.utilities.transformImages(rs);
          } else {
            return this.uploadEnd.emit([...rs, ...this.form.value]);
          }
        } else {
          if (this.isOptimized) {
            const rs = [];
            rs.push({ [result[0].metadata.name]: { url: result[0].downloadURL, path: this.filePath, name: result[0].metadata.name, relation: this.optimizedRelation } });
            return this.utilities.transformImages(rs);
          } else {
            return this.uploadEnd.emit(result[0].downloadURL);
          }
        }
      }).then((result) => {
        if (this.isOptimized) {
          result = toArray(result.data);
          if (this.isMultiple) {
            this.uploadEnd.emit([...result, ...this.form.value]);
          } else {
            this.uploadEnd.emit(result[0]);
          }
        }

        if (load) {
          load.dismiss();
        }
      }).catch((e) => {
        console.error("error de upload", e);
        if (load) {
          load.dismiss();
        }
      });
  }

  public render(file) {
    if (isObject(file)) {
      return file[0];
    }
    return file;
  }

  private calculateType(): string {
    if (this.type) {
      switch (this.type) {
        case "image":
          return "image/*";
        case "video":
          return "video/*";
        case "pdf":
          return "application/pdf";
        case "xls":
          return "application/vnd.ms-excel";
        case "doc":
          return "application/msword,";
        case "ppt":
          return "application/vnd.ms-powerpoint";
        case "json":
          return "application/json";
        
        default:
          return this.accept || "image/*";
      }
    }

    return this.accept || "image/*";
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-file/upload-file.ts